const checkoutProCreationScript = `
const unmountCheckoutPro = async () => {
  if (window.checkoutProController) {
    try {
      await window.checkoutProController.unmount();
      window.checkoutProController = null;
    } catch (error) {
      console.error('Error during unmount:', error);
    }
  }
};

unmountCheckoutPro();

const mp = new MercadoPago(window.checkoutProProps.publicKey, {
  locale: window.checkoutProProps.language,
  trackingDisabled: true
});

const bricksBuilder = mp.bricks({ theme: window.checkoutProProps.theme });
const renderPaymentBrick = async (bricksBuilder) => {
  const settings = {
    initialization: {
      /*
       "amount" é o valor total a ser pago por todos os meios de pagamento
     com exceção da Conta Mercado Pago e Parcelamento sem cartão de crédito, que tem seu valor de processamento determinado no backend através do "preferenceId"
      */
      amount: 5000,
      payer: window.checkoutProProps.payer,
      preferenceId: window.checkoutProProps.preferenceId,
      redirectMode: "modal",
    },
    callbacks: {
      onReady: () => {
        /*
         Callback chamado quando o Brick estiver pronto.
         Aqui você pode ocultar loadings do seu site, por exemplo.
        */
        // dispatchEvent(new Event('paymentBrickReady'));
      },
      onError: (error) => {
        // callback chamado para todos os casos de erro do Brick
        console.error(error);
      },
    },
  };

  window.checkoutProController = await mp.bricks().create("wallet", "checkout-pro_container", settings);
};

renderPaymentBrick(bricksBuilder);
  `;

const paymentMethods = ['credit_card', 'debit_card'];

const creditCardPaymentTypes = [
  'amex',
  'elo',
  'hipercard',
  'master',
  'visa',
  'argencard',
  'cabal',
  'cmr',
  'cencosud',
  'cordobesa',
  'diners',
  'naranja',
  'tarshop',
  'codensa',
  'creditel',
  'oca',
  'cabal',
  'maestro',
  'mastercard',
  'visa',
  'redcompra',
];

const debitCardPaymentTypes = [
  'debcabal',
  'maestro',
  'debmaster',
  'debvisa',
  'redcompra',
];

module.exports = { checkoutProCreationScript, creditCardPaymentTypes, debitCardPaymentTypes, paymentMethods };
